import { createAsyncThunk } from "@reduxjs/toolkit"; 
import { getRolesApi, getUserApi } from "../../../apiservice/setting";

export const fetchRoles = createAsyncThunk(
  "workflow/fetchRoles",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const authInfo = state.auth.auth_info; 

      const res = await getRolesApi({ institution_id: authInfo.id }); 
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchUsers = createAsyncThunk(
  "workflow/fetchUsers",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getUserApi({ "select-type": "active" }); 
      return res.data.message;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
